import { CheckCircleTwoTone, PrinterOutlined, EyeOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Col, Modal, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const ModalWithMessageAndActionReg = (props) => {

  let navigate = useNavigate();

  const changeLocation = (placeToGo) => {
    navigate(placeToGo, { replace: true });
    window.location.reload();
  }

  // useEffect(()=>{
  //   console.log("Props",props)
  // },[props]);

  return (

    <div>

      <>{console.log('props', props)}</>

      <Modal
  title={props.responseModal.responseModalTitle}
  centered
  visible={props.responseModal.isOpenModal}
  open={props.responseModal.isOpenModal}
  closable={false}
  footer={false} // Disable default footer
  className="responseModal"
  width={600} // Adjust the width as needed
>
  <div style={{ textAlign: "center" }}>
    <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: "2.5rem" }} />
    <h3>{props.responseModal.responseModalMessage}</h3>
  </div>
  <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
    {props.responseModal.printReuired && (
      <a href={props?.responseModal?.printUrl} target="_blank" rel="noopener noreferrer">
        <Button htmlType="button" type="default">
          <PrinterOutlined /> Print
        </Button>
      </a>
    )}
    <Link to={props.responseModal.listLink}>
      <Button htmlType="button" type="primary">
        <EyeOutlined /> View List
      </Button>
    </Link>
    <Link to={props.responseModal.addmoreLink} onClick={() => changeLocation(props.responseModal.addmoreLink)}>
      <Button htmlType="button" type="danger" style={{background:'#457533',border:0}}>
        <EyeOutlined /> Add More
      </Button>
    </Link>
    <Link to={`/enrollment-jcp`} onClick={() => changeLocation('/enrollment-jcp')}>
      <Button htmlType="button" type="danger" style={{background:'#c663d5',border:0}}>
        <EyeOutlined /> Junior Coaching Programme
      </Button>
    </Link>
    <Link to={`/high-performance`} onClick={() => changeLocation('/high-performance')}>
      <Button htmlType="button" type="danger" style={{background:'#a69d15',border:0}}>
        <EyeOutlined /> High Performance
      </Button>
    </Link>
    <Link to={`/enrollment-pf`} onClick={() => changeLocation('/enrollment-pf')}>
      <Button htmlType="button" type="danger" style={{background:'#ac7733',border:0}}>
        <EyeOutlined /> Physicall Fitness
      </Button>
    </Link>
  </div>
</Modal>


    </div>
  );
};

export default ModalWithMessageAndActionReg;
